<script setup lang="ts">
import News from '@/core/resources/News'

defineProps({
  news: {
    type: Object as () => News,
    required: true
  }
})
const selected = defineModel<boolean>()
</script>

<template>
  <tr :class="{ selected: selected }">
    <td>
      <input type="checkbox" v-model="selected" />
    </td>
    <td class="title-column">
      <span>
        {{ news.title }}
      </span>
    </td>
    <td class="created-column">
      <span> {{ news.createDate.toLocaleDateString() }} {{ news.createDate.toLocaleTimeString() }} </span>
    </td>
    <td class="updated-column">
      <span> {{ news.updateDate.toLocaleDateString() }} {{ news.updateDate.toLocaleTimeString() }} </span>
    </td>
    <td>
      <router-link :to="'/news/edit/' + news.id" class="material-symbols-outlined action"> edit </router-link>
    </td>
  </tr>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tableline.scss';
</style>
